import { createContext, FunctionComponent, ReactElement, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import Api from "src/Config";

import { useParams } from "react-router-dom";

export const AlertMonitoringDetailContext = createContext(null);

type Props = {
  children: ReactElement;
};

const AlertMonitoringDetailProvider: FunctionComponent<Props> = ({
  children,
}) => {
  const { refId } = useParams();

  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["alert_monitoring_detail"],
    staleTime: 30000,
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`tm/transactions/${refId}/monitor-details`);

      return data;
    },
  });

  const contextValue = useMemo(
    () => ({
      isLoading,
      data,
      error,
      isFetching,
    }),
    [isLoading, data, error, isFetching],
  );
  return (
    <AlertMonitoringDetailContext.Provider value={contextValue}>
      {children}
    </AlertMonitoringDetailContext.Provider>
  );
};

export default AlertMonitoringDetailProvider;
